const ibantools = require('ibantools')

export const validateIban = (iban) => {
  let validIban = false
  // if val contains space
  if (iban.includes(' ')) {
    // remove spaces
    iban = iban.replace(/\s/g, '')
  }

  validIban = ibantools.isValidIBAN(iban)

  return validIban
}

// Vergleichswerte normalisieren, damit Gross-/Kleinschreibung, Leerzeichen,
// Sonderzeichen und Schreibweisen (0171 / +49 171 / 0049 (0)171) nicht zum Umgehen taugen.
// NFKC macht z.B. Vollbreiten-Ziffern/-Zeichen und unsichtbare Varianten vergleichbar.
export const normalizeEmail = (value) => {
  const clean = String(value || '').normalize('NFKC').replace(/[\s\u200B-\u200D\uFEFF]/g, '').toLowerCase()
  const [local = '', domainRaw = ''] = clean.split('@')
  const domain = domainRaw.replace(/\.+$/, '')
  const cleanLocal = local.split('+')[0]
  const isGoogle = domain === 'gmail.com' || domain === 'googlemail.com'
  return (isGoogle ? cleanLocal.replace(/\./g, '') : cleanLocal) + '@' + (isGoogle ? 'gmail.com' : domain)
}

export const normalizePhone = (value) => {
  let digits = String(value || '').normalize('NFKC').replace(/\(0\)/g, '').replace(/\D/g, '')
  if (digits.startsWith('0049')) {
    digits = digits.slice(4)
  } else if (digits.startsWith('49')) {
    digits = digits.slice(2)
  }
  return digits.replace(/^0+/, '')
}
